import { IoAlertCircleOutline } from 'react-icons/io5';

interface Props {
  className?: string
  text: string
}

export default function AlertSquare({ className, text }: Props) {
  return (
    <div
      className={`mb-2 mt-5 flex items-center space-x-2 rounded-md border-t-4 border-yellow-500 bg-gradient-to-b from-yellow-100 to-yellow-50 p-2 ${className}`}
    >
      <div className="flex h-6 w-6 items-center justify-center rounded-full bg-transparent">
        <IoAlertCircleOutline
          size={24}
          style={{ backgroundColor: 'transparent' }}
          className="bg-transparent text-yellow-500"
        />
      </div>
      <p className="text-sm text-gray-700">{text}</p>
    </div>
  )
}
